import * as ActionTypes from '../actions/partner'

const partners = (
  state = {
    isLoading: false,
    list: [],
    next: null,
    query: {}
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.GET_PARTNER_REQUEST:
      return {
        ...state,
        isLoading: true
      }

    case ActionTypes.GET_PARTNER_FAILURE:
      return {
        ...state,
        isLoading: false
      }

    case ActionTypes.GET_PARTNER_SUCCESS:
      return {
        ...state,
        ...action.response,
        isLoading: false
      }

    case ActionTypes.LOAD_PARTNERS_REQUEST: {
      const isLoadMore = action.query && action.query.cursor !== undefined
      return {
        ...state,
        isLoading: true,
        next: isLoadMore ? state.next : null,
        query: action.query
      }
    }

    case ActionTypes.LOAD_PARTNERS_SUCCESS: {
      const isLoadMore = action.query && action.query.cursor !== undefined
      const list = isLoadMore ? state.list : []
      const responseList = action.response.partners || []

      return {
        ...state,
        list: [...list, ...responseList],
        next: action.response.meta && action.response.meta.next,
        isLoading: false
      }
    }

    case ActionTypes.LOAD_PARTNERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        next: null
      }

    case ActionTypes.LIST_PARTNERS_PROJECTS_SUCCESS: {
      const { meta, projects } = action.response
      const list = state.list.length ? [...state.list, ...projects] : projects

      return {
        ...state,
        list,
        meta,
        isLoading: false
      }
    }

    case ActionTypes.LIST_PARTNERS_PROJECTS_FAILURE: {
      const { error } = action

      return {
        ...state,
        ...(error && { error: true }),
        isLoading: false
      }
    }

    case ActionTypes.LIST_PARTNERS_PROJECTS_REQUEST: {
      return {
        ...state,
        isLoading: true
      }
    }

    default:
      return state
  }
}

export default partners
